var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerminationDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.25H6C3.93 4.25 2.25 5.93 2.25 8V16C2.25 18.07 3.93 19.75 6 19.75H18C20.07 19.75 21.75 18.07 21.75 16V8C21.75 5.93 20.07 4.25 18 4.25ZM20.25 16C20.25 17.24 19.24 18.25 18 18.25H6C4.76 18.25 3.75 17.24 3.75 16V8C3.75 6.76 4.76 5.75 6 5.75H18C19.24 5.75 20.25 6.76 20.25 8V16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.25C9.38 7.25 7.25 9.38 7.25 12C7.25 14.62 9.38 16.75 12 16.75C14.62 16.75 16.75 14.62 16.75 12C16.75 9.38 14.62 7.25 12 7.25ZM12 8.75C12.4 8.75 12.77 8.83 13.12 8.96L9.62 14.2C9.08 13.62 8.74 12.85 8.74 11.99C8.74 10.2 10.2 8.74 11.99 8.74L12 8.75ZM12 15.25C11.6 15.25 11.23 15.17 10.88 15.04L14.38 9.8C14.92 10.38 15.26 11.15 15.26 12.01C15.26 13.8 13.8 15.26 12.01 15.26L12 15.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminationDateIcon);
export default __webpack_public_path__ + "static/media/termination_date_icon.216da4688e133a9a0dada2403c0fd47c.svg";
export { ForwardRef as ReactComponent };